/**
 * Keyboard tools.
 */
H_Tools.key = (() => {
    // console.log('Keyboard tools initialized...');

    /**
     * Determines if the supplied event is for the Enter key. Returns a representative boolean
     * value.
     *
     * @param {*} event An event, e.g. from a `keydown` event listener
     */
    function isEnter(event) {
        if ('key' in event) {
            return event.key === 'Enter';
        }
        return event.keyCode === 13;
    }

    /**
     * Determines if the supplied event is for the Escape key. Returns a representative boolean
     * value.
     *
     * @param {*} event An event, e.g. from a `keydown` event listener
     */
    function isEscape(event) {
        if ('key' in event) {
            return event.key === 'Escape' || event.key === 'Esc';
        }
        return event.keyCode === 27;
    }

    /**
     * Determines if the supplied event is for the Space key. Returns a representative boolean
     * value.
     *
     * @param {*} event An event, e.g. from a `keydown` event listener
     */
    function isSpace(event) {
        if ('key' in event) {
            return event.key === ' ' || event.key === 'Spacebar';
        }
        return event.keyCode === 32;
    }

    // return an object to expose inner functions
    return {
        isEnter: isEnter,
        isEscape: isEscape,
        isSpace: isSpace,
    };
})();
